"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.campaign = void 0;
exports.campaign = function (axios) {
    return {
        getCampaigns: function (request) {
            return axios.get('/campaigns', request);
        },
        postCampaignsVerifyDomain: function (request) {
            return axios.post('/campaigns/verify-domain', request.data);
        },
        postCampaignsSettings: function (request) {
            return axios.post('/campaigns/settings', request.data);
        },
        getCampaignsRequirements: function (request) {
            return axios.get('/campaigns/requirements', request);
        },
        getCampaignsSmsAuth: function (request) {
            return axios.get('/campaigns/sms/auth', request);
        },
        postCampaignsSmsAuth: function (request) {
            return axios.post('/campaigns/sms/auth', request.data);
        },
        getCampaignsCountByProductStatus: function (request) {
            return axios.get("/campaigns/count-by-product-status?mallNo=" + request.params.mallNo);
        },
        getCampaignsProductStatuses: function (request) {
            return axios.get("/campaigns/product-statuses?page=" + request.params.page + "&size=" + request.params.size + "&statusTypes=" + request.params.statusTypes + "&mallNo=" + request.params.mallNo);
        },
        getCampaignsAccountByMerchant: function (request) {
            return axios.get('/campaigns/accounts/by-merchant', request);
        },
        postCampaignsAccountReclaimWebsite: function (request) {
            return axios.post("/campaigns/accounts/reclaim-website?mallNo=" + request.params.mallNo);
        },
        getCampaignsStatus: function (request) {
            return axios.get('/campaigns/status', request);
        },
        getCampaignsAccountsByAds: function (request) {
            return axios.get("/campaigns/accounts/by-ads?mallNo=" + request.params.mallNo);
        },
        getCampaignsAccountsAccessUsers: function (request) {
            return axios.get("/campaigns/accounts/access-users?mallNo=" + request.params.mallNo + "&userType=" + request.params.userType);
        },
        postCampaignsAccountsAccessUser: function (request) {
            return axios.post('/campaigns/accounts/access-user', request.data);
        },
        getCampaignsReports: function (request) {
            return axios.get("/campaigns/reports?channels=" + request.params.channels + "&separationType=" + request.params.separationType + "&startDate=" + request.params.startDate + "&endDate=" + request.params.endDate + "&mallNo=" + request.params.mallNo);
        },
    };
};
